import { styled } from '@mui/material';
import { type ReactNode } from 'react';

import ReactHookForm from '@@containers/ReactHookForm/ReactHookForm';
import { type UseReactHookFormProps } from '@@containers/ReactHookForm/types';
import { type InfoboxElement } from '@@editor/helpers/Element';

import { DEFAULT_CONTAINER_TYPE, DEFAULT_INFOBOX_COLLAPSED_VALUE } from '../constants';
import InfoboxFields from './InfoboxFields';

export const DEFAULT_INFOBOX_FORM_VALUES: Pick<InfoboxElement['data'], 'collapsed' | 'style'> = {
    collapsed: DEFAULT_INFOBOX_COLLAPSED_VALUE,
    style: { containerType: DEFAULT_CONTAINER_TYPE },
};

interface IProps {
    type: string;
    element: InfoboxElement;
    className?: string;
    renderButtons: () => ReactNode;
    onCancel: VoidFunction;
    onSubmit: UseReactHookFormProps['onSubmit'];
}

const InfoboxForm = (props: IProps) => {
    const { element, ...rest } = props;
    const initialValues = element?.data || DEFAULT_INFOBOX_FORM_VALUES;

    return (
        <ReactHookForm
            formName="LayoutInfobox"
            values={initialValues}
            hasCancelButton
            hasActiveCancelButton
            alwaysShowCancelButton
            persist={false}
            {...rest}
        >
            <InfoboxFields />
        </ReactHookForm>
    );
};

const ComposedInfoboxForm = styled(InfoboxForm)({
    width: '640px',
});

export default ComposedInfoboxForm;
